import sgWildsComponent from "components/wilds/sg-wilds-component";
import QuickfireRequestSpin from "quickfire/states/quickfire-request-spin";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SgBetBarComponent from "../components/sg-bet-bar-component";
import backgroundTint from "components/show-win-lines/background-tint";

export default class SgRequestSpin extends QuickfireRequestSpin {

    public onEnter() {
        backgroundTint.hide();
        super.onEnter();
    }

    protected newGame() {

        Components.matrix.clearStuckSymbols();
        sgWildsComponent.clearExpandedReels();

        Components.matrix.getReels().forEach((reel) => reel.setVisible(true));

        const lastGame = GameState.getCurrentGame();

        if (lastGame.hasRecords()) {
            const lastRoundWin = lastGame.getTotalWin();

            const betbar = Components.betBar as SgBetBarComponent;
            if (lastRoundWin > 0) {
                betbar.setLastWinnings(lastRoundWin);
            }
        }

        super.newGame();
    }
}
